module.exports = __webpack_public_path__ + "img/x_popup.300a7e69.svg";